import { createSlice } from "@reduxjs/toolkit";
import { clearAuthCookies } from "../utils/cookieUtils";

const initialState = {
  status: null,
  errorCode: null,
  data: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData(state, action) {
      state.status = action.payload.status;
      state.errorCode = action.payload.errorCode;
      state.data = action.payload.data;
    },
    updateTwoFactorAuth(state, action) {
      if (state.data) {
        state.data.twoFactorAuth = action.payload;
      }
    },
    updateUserInformation(state, action) {
      if (state.data) {
        state.data.name = action.payload.name;
        state.data.email = action.payload.email;
        state.data.phone_number = action.payload.phone_number;
        state.data.lang = action.payload.lang;
        state.data.username = action.payload.username;
        state.data.image_url = action.payload.image_url;
      }
    },
    updateUserRoles: (state, action) => {
      if (state.data) {
        state.data.roles = action.payload;
      }
    },
    clearAuthData(state) {
      state.status = null;
      state.errorCode = null;
      state.data = null;
      
      // Clear secure cookies when auth data is cleared
      try {
        clearAuthCookies();
      } catch (error) {
        console.error('Failed to clear auth cookies:', error);
      }
    },
  },
});

export const {
  setAuthData,
  clearAuthData,
  updateTwoFactorAuth,
  updateUserInformation,
  updateUserRoles
} = authSlice.actions;

export const selectUserInformations = (state) => state.auth.data;

export default authSlice.reducer;
